import "inputmask"

if (document.getElementById('join-stream')) {
    jQuery(document).ready(function(){
        let countrySelect = $("#register-form-country_id");
        let countries = {
            1: {name: 'Россия', mask: "+7 (\\999) 999-99-99", placeholder: "+7 (999) 999-99-99"},
            2: {name: 'Украина', mask: "+380 99 999 9999", placeholder: "+380 99 999 9999"},
            3: {name: 'Беларусь', mask: "+375 99 999-99-99", placeholder: "+375 99 999-99-99"},
            4: {name: 'Казахстан', mask: "+7 (999) 999 9999", placeholder: "+7 (999) 999 9999"},
            5: {name: 'Азербайджан', mask: "+\\9\\94 (99) 999 99 99", placeholder: "+994 (99) 999 99 99"},
            6: {name: 'Армения', mask: "+374 99 999 999", placeholder: "+374 99 999 999"},
            7: {name: 'Грузия', mask: "+\\9\\95 999 99 99 99", placeholder: "+995 999 99 99 99"},
            8: {name: 'Израиль', mask: "+\\972 99 999 99 99", placeholder: "+972 99 999 99 99"},
            9: {name: 'США', mask: "+1 (999) 999-9999", placeholder: "+1 (999) 999-9999"}
        };
        if (typeof countries[country] !== 'undefined') {
            $("#register-form-phone").inputmask({"mask": countries[country].mask, clearMaskOnLostFocus: true});
            $("#register-form-phone").attr('placeholder', countries[country].placeholder)
        }
        countrySelect.on('change', function (e) {
            if (typeof countries[this.value] !== 'undefined') {
                $("#register-form-phone").inputmask({"mask": countries[this.value].mask, clearMaskOnLostFocus: true});
                $("#register-form-phone").attr('placeholder', countries[this.value].placeholder)
            } else {
                $("#register-form-phone").inputmask('remove');
                $("#register-form-phone").removeAttr('placeholder');
            }
        });
    });
}


